import React, { useState } from 'react';
import { FileText, Download, X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function WorksheetViewer({ worksheet, onClose }) {
  const [pageNum, setPageNum] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = worksheet.url;
    link.download = worksheet.filename || worksheet.title;
    link.click();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-6xl w-full max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center space-x-4">
            <FileText className="w-6 h-6 text-purple-600" />
            <div>
              <h2 className="text-xl font-semibold text-gray-900">{worksheet.title}</h2>
              {worksheet.description && (
                <p className="text-sm text-gray-600">{worksheet.description}</p>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <button
              onClick={handleDownload}
              className="p-2 text-gray-600 hover:text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
              title="Download PDF"
            >
              <Download className="w-5 h-5" />
            </button>
            <button
              onClick={onClose}
              className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              title="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 overflow-auto p-4 bg-gray-100 flex items-center justify-center">
          <div className="bg-white shadow-lg" style={{ transform: `scale(${scale})`, transformOrigin: 'top center' }}>
            <iframe
              src={worksheet.url.includes('%20') ? worksheet.url : encodeURI(worksheet.url)}
              className="w-full"
              style={{ height: '70vh', minWidth: '800px' }}
              title={worksheet.title}
            />
          </div>
        </div>

        {/* Controls */}
        <div className="flex items-center justify-between p-4 border-t bg-gray-50">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setPageNum(Math.max(1, pageNum - 1))}
              disabled={pageNum === 1}
              className="p-2 rounded-lg hover:bg-purple-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <span className="text-sm text-gray-600">
              Page {pageNum}
            </span>
            <button
              onClick={() => setPageNum(pageNum + 1)}
              className="p-2 rounded-lg hover:bg-purple-100 transition-colors"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
          
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setScale(Math.max(0.5, scale - 0.25))}
              className="px-3 py-1 text-sm border rounded-lg hover:bg-purple-100 transition-colors"
            >
              -
            </button>
            <span className="text-sm text-gray-600 w-16 text-center">
              {Math.round(scale * 100)}%
            </span>
            <button
              onClick={() => setScale(Math.min(2, scale + 0.25))}
              className="px-3 py-1 text-sm border rounded-lg hover:bg-purple-100 transition-colors"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

